import type * as React from 'react'

import { Kbd } from '../Kbd'

import styles from './Tooltip.module.css'

function TooltipShortcut({
  shortcut,
}: {
  shortcut: string
}): React.JSX.Element {
  return (
    <span className={styles.shortcut}>
      {shortcut.split('+').map((key) => (
        <Kbd color="inverted" key={key}>
          {key}
        </Kbd>
      ))}
    </span>
  )
}

export { TooltipShortcut }
